import { getBrowserStorage } from "./browserStorage";

const STORAGE_KEY = "tavela.soundEffectVolumePercent";
export const DEFAULT_SFX_VOLUME_PERCENT = 80;

function parseSoundEffectVolume(value: unknown): number | null {
  if (typeof value === "number" && Number.isFinite(value)) {
    return value;
  }

  if (typeof value === "string" && value.trim().length > 0) {
    const parsedValue = Number(value);
    return Number.isFinite(parsedValue) ? parsedValue : null;
  }

  return null;
}

function normalizeSoundEffectVolume(value: unknown): number {
  const parsedValue = parseSoundEffectVolume(value);
  if (parsedValue === null) {
    return DEFAULT_SFX_VOLUME_PERCENT;
  }

  return Math.min(100, Math.max(0, Math.round(parsedValue)));
}

export function loadSoundEffectVolume(): number {
  const storage = getBrowserStorage();
  if (storage === null) {
    return DEFAULT_SFX_VOLUME_PERCENT;
  }

  try {
    const storedValue = storage.getItem(STORAGE_KEY);
    if (storedValue === null) {
      return DEFAULT_SFX_VOLUME_PERCENT;
    }

    return normalizeSoundEffectVolume(JSON.parse(storedValue));
  } catch {
    return DEFAULT_SFX_VOLUME_PERCENT;
  }
}

export function saveSoundEffectVolume(value: unknown): number {
  const nextVolume = normalizeSoundEffectVolume(value);
  const storage = getBrowserStorage();
  if (storage === null) {
    return nextVolume;
  }

  try {
    storage.setItem(STORAGE_KEY, JSON.stringify(nextVolume));
  } catch {
    // Ignore storage write failures so SFX defaults still work.
  }

  return nextVolume;
}
